import React from 'react'
import './portfolio.css'
import img1 from '../../assets/age.jpeg'
import img2 from '../../assets/hotel.jpeg'
import img3 from '../../assets/hospital.jpg'
import img4 from '../../assets/employ.jpeg'
import img5 from '../../assets/ecom.jpeg'

const data = [
  {
    id:1,
    image: img1,
    title: 'Simple Age Calculator Project',
    github: 'https://github.com/231pizzy/Age-calculator',
    demo: ''
  },
  {
    id:2,
    image:img2,
    title: 'Hotel Booking and Reservation App',
    github: 'https://github.com/231pizzy/Age-calculator',
    demo: ''
  },
  {
    id:3,
    image: img3,
    title: 'HealthBook: Streamlined Doctor Appointment Booking',
    github: 'https://github.com/231pizzy/Age-calculator',
    demo: ''
  },
  {
    id:4,
    image: img4,
    title: 'WorkforcePro: Efficient Employee Management Solution',
    github: 'https://github.com/231pizzy/Age-calculator',
    demo: ''
  },
  {
    id:5,
    image:img5,
    title: 'shopEazy: Simplified E-commerce Shopping Experience',
    github: 'https://github.com/231pizzy/Age-calculator',
    demo: ''
  }

]

const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className='container portfolio__container' >
      {
         data.map(({id, image, title, github, demo}) => {
          return (
          <article key={id} className='portfolio__item'>
             <div className='portfolio__item-image'>
            <img src={image} alt={title}/>
             </div>
          <h3>{title}</h3>
          <div className='portfolio__item-cta'>
          <a href={github} className='btn'>Github</a>
          <a href={demo} className='btn btn-primary' target='_blank'>Live Demo</a>
          </div>
         
        </article> 
         )
         })
      }
      </div>
    </section>
  )
}

export default Portfolio